import { render, staticRenderFns } from "./TaskTreeCommentChild.vue?vue&type=template&id=77bdb14e&scoped=true&"
import script from "./TaskTreeCommentChild.vue?vue&type=script&lang=js&"
export * from "./TaskTreeCommentChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bdb14e",
  null
  
)

export default component.exports